import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { UserQuery, UserService } from '@examdojo/user';
import { isNotNullish } from '@examdojo/util/nullish';
import { EMPTY, filter, switchMap, take } from 'rxjs';

@Injectable()
export class ResetOnboardingStepWhenOnboarded {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly userService: UserService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
    this.userQuery.onboardedUser$
      .pipe(
        filter(isNotNullish),
        take(1),
        switchMap((user) => {
          if (!user.current_onboarding_step) {
            return EMPTY;
          }
          return this.userService
            .update(user.id, { current_onboarding_step: null })
            .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY));
        }),
      )
      .pipe(takeUntilDestroyed())
      .subscribe();
  }
}
